import React from "react";
import { Row, Col } from "react-bootstrap";
import { Helmet } from "react-helmet";
import ProductBox from "../../components/product-box";
import lips from "../../data/lips";
import Select from "react-select";

const options = [
  { value: "Position", label: "Position" },
  { value: "Product Name", label: "Product Name" },
  { value: "Price", label: "Price" },
];

const ShopLips = () => {
  return (
    <section className="eyes ptb-30">
      <Helmet>
        <title>Lips Collection | Brow Bar by Reema</title>
      </Helmet>

      <div className="container">
        <h2>LIPS COLLECTION</h2>
        <Row className="justify-content-center">
          <Col lg="12" sm="12">
            <div className="banner">
              <img
                src={require("../../assets/banners/lips-banner.jpg")}
                alt="Brow Collection | Brow Bar by Reema"
              />
            </div>
          </Col>
          <Col lg="6" sm="12">
            <div className="heading">
              <p>
                Brow Bar by Reema's lip collections come in various finishes and
                colors to match whatever look you are creating. From matte,
                gloss, to shimmer we've got you covered.
              </p>
            </div>
          </Col>
        </Row>
        <Row className="products-list border-top-section ptb-30">
          <div className="container">
            <div className="product-stats">
              <p>We have total 19 products</p>
              <Select
                options={options}
                classNamePrefix="select-control"
                placeholder="Sort by"
                name="sort-by"
                id="sort-by"
              />
            </div>
            <Row>
              {lips.map((product) => {
                return (
                  <Col lg="3" sm="12" key={product.id}>
                    <ProductBox
                      isOutOfStock={product.isOutOfStock}
                      productFrontImg={product.productFrontImg}
                      productBackImg={product.productBackImg}
                      productName={product.productName}
                      productPrice={product.productPrice}
                    />
                  </Col>
                );
              })}
            </Row>
          </div>
        </Row>
      </div>
    </section>
  );
};

export default ShopLips;
